import React from 'react';

import { IconAnonymousL, IconAnonymousXL, IconAnonymousXXL } from '../../icons';

export const AVATAR_SIZES = '(max-width: 240px) 40px, (max-width: 480px) 60px, 96px';

export const AVATAR_IMAGE_VARIANTS = [
    // 240x240
    'square-small',

    // 480x480
    'square-small2x',
];

export const anonymIconsMapper = {
    large: (props = {}) => <IconAnonymousXL {...props} />,
    extraLarge: (props = {}) => <IconAnonymousXXL {...props} />,
};

export const renderAnonymIcon = (avatarType, props = {}) =>
    anonymIconsMapper[avatarType] ? (
        anonymIconsMapper[avatarType](props)
    ) : (
        <IconAnonymousL {...props} />
    );
